// import { Box, Skeleton, useMediaQuery } from "@chakra-ui/react";
import {
  // Avatar,
  Box,
  Grid,
  HStack,
  Image,
  Stack,
  Text,
  useMediaQuery,
} from "@chakra-ui/react";
import ReactGA from "react-ga4";
import { Helmet } from "react-helmet";

import FilteredGames from "../Components/Games/FilteredGames";
import { useFilteredGames, useGames, useCategories, useGamesByCategories, usePlayedGames } from "../Hooks/useGetGames";
// import Carousel from "../Components/Carousel/Carousel";
import NewsCarousel from "../Components/Carousel/NewsCarousel";
import GameBannerAd from "../Components/Advertisement/GameBannerAd";
// import ComicPanel from "../Components/Comics/ComicPanel";
// import taktLogo from "../assets/LBPortal_Graphic_AdBG.webp";
// import Blogs from "../Components/Games/Blogs";
// import { motion } from "framer-motion";
// import { useEffect, useState } from "react";

import placeholderThumbnail from "../assets/GameThumbnail_Empty.png";
import { Fragment, useEffect, useState } from "react";

function Homepage() {
  ReactGA.send({
    hitType: "pageview",
    page: "/",
    title: "Home",
  });
  const { data, isLoading } = useGames();
  
  // add await here
  /*
    Supposedly for dynamic category fetching (instead, wait for approval)
  */
  const { isCategoriesLoading, categories, gamesByCategory } = useGamesByCategories();
  const { data: recentlyPlayedGames, isLoading: isRecentlyPlayedLoading } = usePlayedGames();

  //try mobile
  const [isLargerThan1580] = useMediaQuery("(min-width: 1580px)");

  // useEffect(() => {
  //   setTimeout(() => {
  //     setSkeleton(true);
  //   }, 1000);
  // }, []);
  
  if (isLoading || isCategoriesLoading) return <div />;
  

  /* const carouselGames = data.games.filter(
    (game) => game.is_display_in_slideshow === true
  ); */

  const manuallySetNewReleases = data.games.filter((game) => game.marked_as_new_release);
  const newReleases = manuallySetNewReleases.length > 0 ?
    manuallySetNewReleases :
    data.games
      .filter(game => game.release_date)
      .sort((a, b) => new Date(b.release_date) - new Date(a.release_date))
      .slice(0, 6);

  return (
    <>
      <Helmet>
        <title>Leaderbored</title>
        <link rel="canonical" href="https://www.leaderbored.gg" />
        <meta
          name="description"
          content="Page consisting of webcomics and free HTML5 games to play."
        />
      </Helmet>
      
      {/* <Box
        position="relative"
        left="50%"
        w="100vw"
        maxW="100vw"
        transform="translateX(-50%)"
        overflowX="hidden"
        paddingLeft="35px"
        paddingRight="35px"
      >
        <NewsCarousel />
      </Box> */}
      
      <Box color="white"
      >
        {/* Hide Carousel, Comic, GOTW, etc */}
        {/* <div style={{ display: "none"}>
          <Carousel games={carouselGames} />
          <GameBannerAd />
          <Box id="comics">
            <ComicPanel />
          </Box>

          <Box
            bgImage={taktLogo}
            bgPos="center"
            bgSize="cover"
            borderRadius="20px"
            mb="40px"
            bgRepeat="no-repeat"
          >
            <FilteredGames
              heading={"Game of the week"}
              games={[singlePlayer[0]]}
            />
          </Box>
        </div> */}

        {/* <Box
          position="relative"
          left="50%"
          right="50%"
          ml="-48vw"
          mr="-53vw"
          w="96vw"
          mt="-30px"
        >
          
        </Box> */}
        
        {/* <Box mt="24px">
          <FilteredGames
            heading={"New Releases"}
            games={newReleases}
            isPC={isLargerThan1580}
          />
        </Box>


        {triviaGamesData.games.length > 0 &&
          <Box mt="24px">
            <FilteredGames
              heading={"Trivia Games"}
              games={triviaGamesData.games}
              isPC={isLargerThan1580}
            />
          </Box>}

        <GameBannerAd />

        <Box mt="24px">
          <FilteredGames
            heading={"Single player"}
            games={singlePlayer}
            isPC={isLargerThan1580}
          />
        </Box>

        <GameBannerAd />

        <FilteredGames
          heading={"Multiplayer"}
          games={multiPlayer}
          isPC={isLargerThan1580}
        /> */}
        {/* <GameBannerAd /> */}
        {/* <Blogs heading={"News and Updates"} isPC={isLargerThan1580} /> */}
        {/* <GameBannerAd /> */}
        {/* {recentlyPlayedGames && recentlyPlayedGames.length > 0 && (
          <Box mt="20px">
            <FilteredGames
              heading={"Recently Played"}
              games={recentlyPlayedGames}
              isPC={isLargerThan1580}
            />
          </Box>
        )} */}

        <GameBannerAd />

        <Box mt="24px"> 
          <FilteredGames
            heading={"New Releases"}
            games={newReleases}
            isPC={isLargerThan1580}
          />
        </Box>

        <GameBannerAd />

        {categories.map((cat) => {
          // Only show if there are games in the category
          const games = gamesByCategory[cat];
          if (!games) return null;
          return (
            <Fragment key={cat}> {/* stop the compiler from complaining about key values for lists */}
              <Box mt="24px">
                <FilteredGames
                  heading={cat.split(" ").map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(" ")}
                  games={games}
                  isPC={isLargerThan1580}
                />
              </Box>

              <GameBannerAd />
            </Fragment>
          );
        })}
      </Box>
    </>
  );
}

function BlogsMini() {
  const [blogs, setBlogs] = useState([]);
  const maxTitle = 10;
  const maxChars = 53;

  useEffect(() => {
    const url =
      "https://www.googleapis.com/blogger/v3/blogs/460807346859212205/posts?key=AIzaSyBqKzXCCGSnRfDLxIZ7R64sIv7L3KlzJ10";

    fetch(url)
      .then((response) => response.json())
      .then((data) => {
        // Handle the response data here
        console.log(data);
        setBlogs(data.items);
      })
      .catch((error) => {
        // Handle any errors that occurred during the request
        console.error(error);
      });
  }, []);

  const getImage = (e) => {
    // e.currentTarget.src = thumbnail;

    const str = `<p>&nbsp;</p><div class="separator" style="clear: both; text-align: center;"><a href="https://blogger.googleusercontent.com/img/b/R29vZ2xl/AVvXsEjTRB1y4jODiZW3kh0cSO1VjXeRfJ952g2OPfnS_g2EjqPYTqAkSbkbvIIIgcpZu_0SdHxH78ECoAXQYR3dcgKjPflq9zN8bAVDgGHXBxtJDOP2XkX0utsDzP-eCSAxqAa2IEqQp3DRWPKz9dfYQOSC73gCjvIuViAF5Y37_xyYRalv7mLtc7cG_ey0HvqZ/s7200/Leader%20Bored%20Group%20Shot.png" imageanchor="1" style="margin-left: 1em; margin-right: 1em;"><img border="0" data-original-height="5400" data-original-width="7200" height="240" src="https://blogger.googleusercontent.com/img/b/R29vZ2xl/AVvXsEjTRB1y4jODiZW3kh0cSO1VjXeRfJ952g2OPfnS_g2EjqPYTqAkSbkbvIIIgcpZu_0SdHxH78ECoAXQYR3dcgKjPflq9zN8bAVDgGHXBxtJDOP2XkX0utsDzP-eCSAxqAa2IEqQp3DRWPKz9dfYQOSC73gCjvIuViAF5Y37_xyYRalv7mLtc7cG_ey0HvqZ/s320/Leader%20Bored%20Group%20Shot.png" width="320" /></a><br /><br />For news and updates on the Leader Bored gang!</div><br /><p></p>`;

    const regex = /<img\s+[^>]*src="([^"]+)"/g;
    const matches = str.match(regex);

    const imageLinks = matches.map((match) => match.match(/src="([^"]+)"/)[1]);

    if (imageLinks.length > 0) {
      e.currentTarget.src = imageLinks[0];
    }
  };

  function processText(html, maxLength = 53) {
    // 1. Remove HTML tags
    let text = html.replace(/<[^>]*>/g, " ");

    // 2. Replace HTML entities like &nbsp;
    const textarea = document.createElement("textarea");
    textarea.innerHTML = text;
    text = textarea.value;

    // 3. Normalize spaces
    text = text.replace(/\s+/g, " ").trim();

    // 4. Trim to maxLength with trailing ...
    if (text.length > maxLength) {
      return text.substring(0, maxLength).trim() + "...";
    }

    return text;
  }

  return (
    <Grid
      templateColumns={{
        base: "repeat(2, 1fr)",
        sm: "repeat(3, 1fr)",
        md: "repeat(4, 1fr)",
        lg: "repeat(5, 1fr)",
        xl: "repeat(6, 1fr)",
      }}
      gap={{ base: 4, md: 5, xl: 6 }}
      w="100%"
      maxW="100%"
      m={0}
      px={{ base: 2, md: 4 }}
      py={{ base: 2, md: 4 }}
      alignItems="stretch"
      justifyItems="stretch"
      mb="12px"
    >
      {blogs.map((b, index) => {
        const { title, blog, url, content } = b;
        return (
          <a key={b.id || url || index} href={url} target="_blank">
            <HStack w={"270px"}>
              <Image
                boxSize={"60px"}
                borderRadius={"14px"}
                src={placeholderThumbnail}
                loading="lazy"
                // objectFit="cover"
                objectFit="contain"
              />
              <Stack spacing={"0px"}>
                <Text fontWeight={"bold"} fontSize={"18px"}>
                  {title}
                </Text>
                <Text lineHeight={"20px"}>{processText(content, 53)}</Text>
              </Stack>
            </HStack>
          </a>
        );
      })}
    </Grid>
  );
}

export default Homepage;
